/**
 * SelectInput — Figma `Input` 드롭다운(라운드 4, 테두리 Line/Normal, ChevronDown 14).
 *
 * Combo(Button/Combo Transparent)와 같은 단일 선택이지만 트리거 생김새가 다른 별도 Figma 컴포넌트다.
 * shadcn `Select` 의존과 내부 구조 셀렉터(`[&>span:first-child]`)를 화면 코드가 아닌 여기 한곳에 가둔다.
 *
 * ponytail: Combo 와 합치지 않았다. 두 variant 가 공유하는 스타일이 사실상 없어 cva 로 묶으면
 * Combo 기존 사용처만 흔들린다. shadcn 을 걷어낼 때 두 파일을 함께 옮긴다.
 */
import { cn } from "@/lib/utils";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/styles/ui/select";

export const SelectInput = <T extends string>({
  label,
  value,
  options,
  onChange,
  disabled,
  className,
}: {
  /** 보이는 라벨이 없으므로 접근성 이름으로 쓴다 */
  label: string;
  value: T;
  options: { value: T; label: string }[];
  onChange: (value: T) => void;
  disabled?: boolean;
  className?: string;
}) => (
  <Select
    value={value}
    onValueChange={(next) => onChange(next as T)}
    disabled={disabled}
  >
    <SelectTrigger
      aria-label={label}
      className={cn(
        "label-1-normal-regular h-9 min-w-0 rounded border-line-normal bg-white px-3 text-label-normal shadow-none [&>svg]:size-3.5 [&>svg]:opacity-100",
        className,
      )}
    >
      <SelectValue />
    </SelectTrigger>
    {/* Figma 6895-752459 — 선택 표시는 체크 아이콘 대신 blue-50 배경 */}
    <SelectContent className="rounded-xl border-neutral-200 bg-white shadow-xlarge">
      {options.map((option) => (
        <SelectItem
          key={option.value}
          value={option.value}
          className="label-1-normal-medium mt-1 cursor-pointer rounded-lg px-3 py-1.5 text-label-normal first:mt-0 focus:bg-blue-50 data-[state=checked]:bg-blue-50 [&>span:first-child]:hidden"
        >
          {option.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
